/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
'use strict';

const bubble = {
    DEFAULT: 'default',
    INFORMATIVE: 'informative',
    POSITIVE: 'positive-dark',
    WARNING: 'warning',
};

const primeSidebar = {
    DEFAULT: 'default',
    LOGGED_APPLIED: 'logged-applied',
    MEMBER_NOT_TRAVELERS: 'member-not-travelers',
    LOGGED_PRIME_BLOCKED: 'logged-prime-blocked',
    APPLIED: 'applied',
    LOGGED_FREE_APPLIED: 'logged-free-applied',
    NOT_APPLIED: 'not-applied',
    SUBSCRIPTION_ADDED: 'subscription-added',
    NON_LOGGED_APPLIED: 'non-logged-applied',
};

function isPassengersPage(page) {
    return page === 'details';
}

function isPaymentPage(page) {
    return page === 'payment';
}

function isMemberNotLoggedInTravellers(memberLogged, memberInTravellers, memberTestActive) {
    return !memberLogged && memberInTravellers && memberTestActive;
}

function isSubscriptionNotAdded(memberTestActive, subscriptionAdded) {
    return memberTestActive && !subscriptionAdded;
}

function isCheapestPriceSelected(cheapestPriceSelected, memberTestActive) {
    return cheapestPriceSelected && memberTestActive;
}

function isCheapestPriceSelectedAndNotSubscription(cheapestPriceSelected, memberTestActive, subscriptionAdded) {
    return isCheapestPriceSelected(cheapestPriceSelected, memberTestActive) && !subscriptionAdded;
}

function isSubscriptionAdded(subscriptionAdded, memberTestActive) {
    return memberTestActive && subscriptionAdded;
}

function isMemberBetweenTravellers(memberLogged, memberInTravellers, isPrimeTravellerUnselected, isFreeAccount, page) {
    const isMemberBetweenTravellersInPax = isPassengersPage(page) && memberLogged && !isFreeAccount &&
        (memberInTravellers || !isPrimeTravellerUnselected);
    const isMemberBetweenTravellersInPay = isPaymentPage(page) && memberLogged && memberInTravellers;
    return isMemberBetweenTravellersInPax || isMemberBetweenTravellersInPay;
}

function isMemberNotInTravellers(memberTestActive, memberLogged, memberInTravellers) {
    return memberTestActive && memberLogged && !memberInTravellers;
}

function isSubscriptionAddedInPayment(memberLogged, memberTestActive, memberInTravellers, page) {
    return isPaymentPage(page) && !memberLogged && memberTestActive && memberInTravellers;
}

function checkAutoApplyDiscount(memberLogged, isAutoApplyDiscount, page) {
    return isPaymentPage(page) && !memberLogged && isAutoApplyDiscount;
}

function getStatus(memberLogged, memberTestActive, subscriptionAdded, memberInTravellers, cheapestPriceSelected,
    isFreeAccount, isPrimeTravellerUnselected, isPrimeBlocked, isAutoApplyDiscount, page) {
    let status = {
        bubble: bubble.DEFAULT,
        primeSidebar: primeSidebar.DEFAULT,
    };

    if (checkAutoApplyDiscount(memberLogged, isAutoApplyDiscount, page)) {
        status = {
            bubble: bubble.POSITIVE,
            primeSidebar: primeSidebar.NON_LOGGED_APPLIED,
        };
    } else if (isPaymentPage(page) && isPrimeBlocked) {
        status = {
            bubble: bubble.DEFAULT,
            primeSidebar: primeSidebar.LOGGED_PRIME_BLOCKED,
        };
    } else if (isSubscriptionAdded(subscriptionAdded, memberTestActive) ||
        isSubscriptionAddedInPayment(memberLogged, memberTestActive, memberInTravellers, page)) {
        status = {
            bubble: bubble.POSITIVE,
            primeSidebar: primeSidebar.SUBSCRIPTION_ADDED,
        };
    } else if (isMemberBetweenTravellers(memberLogged, memberInTravellers, isPrimeTravellerUnselected, isFreeAccount, page)) {
        status = {
            bubble: bubble.INFORMATIVE,
            primeSidebar: primeSidebar.LOGGED_APPLIED,
        };
    } else if (isCheapestPriceSelectedAndNotSubscription(cheapestPriceSelected, memberTestActive, subscriptionAdded) &&
        isMemberNotInTravellers(memberTestActive, memberLogged, memberInTravellers) && isFreeAccount) {
        status = {
            bubble: bubble.INFORMATIVE,
            primeSidebar: primeSidebar.LOGGED_FREE_APPLIED,
        };
    } else if (isMemberNotInTravellers(memberTestActive, memberLogged, memberInTravellers)) {
        status = {
            bubble: bubble.DEFAULT,
            primeSidebar: primeSidebar.MEMBER_NOT_TRAVELERS,
        };
    } else if ((isCheapestPriceSelectedAndNotSubscription(cheapestPriceSelected, memberTestActive, subscriptionAdded) && isPassengersPage(page)) ||
        (isMemberNotLoggedInTravellers(memberLogged, memberInTravellers, memberTestActive) && isPaymentPage(page))) {
        status = {
            bubble: bubble.INFORMATIVE,
            primeSidebar: primeSidebar.APPLIED,
        };
    } else if (isSubscriptionNotAdded(memberTestActive, subscriptionAdded)) {
        status = {
            bubble: bubble.DEFAULT,
            primeSidebar: primeSidebar.NOT_APPLIED,
        };
    }
    return status;
}

module.exports = {
    getStatus: function(membershipSettings, page) {
        return getStatus(membershipSettings.isMemberLogged, membershipSettings.isMemberTestActive,
            membershipSettings.isSubscriptionAdded, membershipSettings.memberInTravellers,
            membershipSettings.isCheapestPriceSelected, membershipSettings.isFreeAccount,
            membershipSettings.isPrimeTravellerUnselected, membershipSettings.isPrimeBlocked,
            membershipSettings.isAutoApplyDiscount, page);
    },
};
